import { useEffect, useState } from "react";
import { Phone, MapPin, Globe } from "lucide-react";
import { api } from "../lib/api";

const BG = "https://customer-assets.emergentagent.com/job_chatbot-finder-pro/artifacts/rwunl9ls_IMG_1682.jpeg";

export default function LocalServices() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/local-services").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <main
      className="relative min-h-screen"
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0.05) 45%, rgba(0,0,0,0.22) 100%), url(${BG})`,
        backgroundSize: 'cover, cover',
        backgroundPosition: 'center, center',
        backgroundAttachment: 'scroll, scroll',
        backgroundRepeat: 'no-repeat, no-repeat',
      }}
    >
      <section className="container mx-auto px-6 pt-20 pb-12">
        <div className="bg-white/55 backdrop-blur-md border border-white/60 ring-1 ring-black/5 p-8 max-w-2xl shadow-2xl">
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#15803D] mb-4">
            ◆ Whitsundays · Trusted Trades
          </div>
          <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter text-zinc-950 leading-[0.95]">
            Services we<br/>use & recommend.
          </h1>
          <p className="mt-5 text-zinc-800 leading-relaxed">
            Not everything is a caravan repair. If your job sits outside what we do at Nomad, here's the local crew we'd send our own customers to. No commissions, no kickbacks — just trades we trust.
          </p>
        </div>
      </section>

      <section className="container mx-auto px-6 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((s) => (
            <div key={s.id} data-testid={`local-service-${s.id}`} className="bg-white/45 backdrop-blur-md border border-white/50 ring-1 ring-black/5 p-6 hover:bg-white/65 hover:border-[#16A34A] transition-all flex flex-col gap-3 shadow-xl">
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#15803D]">{s.trade}</div>
              <h3 className="font-display font-bold text-xl text-zinc-950 leading-tight">{s.name}</h3>
              <p className="text-sm text-zinc-800 leading-relaxed">{s.description}</p>
              <div className="mt-auto pt-4 border-t border-white/50 space-y-2">
                {s.suburb && (
                  <div className="flex items-center gap-2 text-sm text-zinc-800">
                    <MapPin className="w-3.5 h-3.5 text-zinc-500" /> {s.suburb}
                  </div>
                )}
                {s.phone && (
                  <a href={`tel:${s.phone.replace(/\s/g,'')}`} data-testid={`local-call-${s.id}`} className="flex items-center gap-2 text-sm font-semibold text-zinc-950 hover:text-[#15803D]">
                    <Phone className="w-3.5 h-3.5" /> {s.phone}
                  </a>
                )}
                {s.website && (
                  <a href={s.website} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-sm font-semibold text-zinc-950 hover:text-[#15803D]">
                    <Globe className="w-3.5 h-3.5" /> Website
                  </a>
                )}
              </div>
            </div>
          ))}
          {items.length === 0 && (
            <div className="bg-white/55 backdrop-blur-md p-12 text-center col-span-full text-zinc-700">
              No local services listed yet.
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
